<svelte:options runes={true} />

<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    children?: Snippet;
    class?: string;
  }

  let { children, class: className = "" }: Props = $props();
</script>

<div class="da-slide-over-dialog-footer {className}">
  {#if children}{@render children()}{/if}
</div>

<style>
  @layer aurora {
    :global(.da-slide-over-dialog-footer) {
      display: flex;
      gap: var(--da-space-3);
      position: relative;
      width: calc(100% + var(--overlay-anim-overflow, 20%));
      left: calc((var(--overlay-anim-overflow, 20%) / 2) * -1);
      padding-block: var(--da-space-4);
      padding-inline: calc(var(--overlay-anim-overflow, 20%) - var(--da-space-4));
      background: var(--da-color-brand-sand-500);
      flex-shrink: 0;
    }
  }
</style>
